/**
 * StampUserList - スタンプ取得者リスト
 *
 * ソート: 早い順（acquiredAt 昇順）で固定。切り替えUIは持たない。
 * Firestore側で orderBy('acquiredAt', 'asc') 済みの配列をそのまま表示する。
 *
 * 先行者利益: より早くスタンプを取得したユーザーが上位に表示される。
 */

import GoldMedalIcon from '../common/icons/GoldMedalIcon';

/**
 * Firestore Timestamp または Date を "YYYY/MM/DD HH:mm" 形式の文字列に変換する
 * @param {import('firebase/firestore').Timestamp | Date | null} value
 * @returns {string}
 */
const formatAcquiredAt = (value) => {
  if (!value) return '—';
  // Firestore Timestamp は .toDate() で Date に変換できる
  const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
  if (isNaN(date.getTime())) return '—';
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const mi = String(date.getMinutes()).padStart(2, '0');
  return `${y}/${mo}/${d} ${h}:${mi}`;
};

const StampUserList = ({ users }) => {
  if (!users || users.length === 0) {
    return (
      <p className="py-4 text-center text-sm text-gray-400">
        まだスタンプ取得者はいません
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {/* ヘッダー */}
      <div className="flex items-baseline justify-between">
        <h3 className="text-sm font-bold text-gray-700">
          スタンプ取得者（取得順）
        </h3>
        <span className="text-xs text-gray-400">{users.length}人</span>
      </div>
      {/* 金メダルアイコン説明文 */}
      <p className="flex items-center gap-1 text-[11px] text-gray-400">
        <GoldMedalIcon size={16} />
        <span>は有料版スタンプカードを購入した方の称号です</span>
        {/* スクリーンリーダー向け補足 */}
        <span className="sr-only">（金メダルアイコンは有料版スタンプカードを購入した方の称号です）</span>
      </p>
      <ul className="divide-y divide-gray-100">
        {users.map((user, index) => (
          <li
            key={user.userId}
            className="flex items-center gap-3 py-2"
          >
            {/* 順位バッジ */}
            <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-100 text-xs font-bold text-gray-500">
              {index + 1}
            </span>
            {/* ユーザー名 */}
            <p className="min-w-0 flex-1 truncate text-sm font-medium text-gray-800">
              {user.displayName || '名無し'}
            </p>
            {/* 有料版スタンプカード保持者アイコン */}
            {(user.paidCount ?? 0) >= 1 && (
              <span className="flex-shrink-0" title="有料版スタンプカード購入者">
                <GoldMedalIcon size={20} />
                <span className="sr-only">有料版スタンプカード購入者</span>
              </span>
            )}
            {/* 最終取得日時 */}
            <span className="flex-shrink-0 text-xs text-gray-400">
              {formatAcquiredAt(user.acquiredAt)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StampUserList;
